import * as S from "./InquirySideMenuList.style";
import { LoginType } from "@/common/states/user";
import { UserSideMenuItem as InquirySideMenuItem } from "@/components/atoms/UserSideMenuItem";

interface InquirySideMenuListProps {
  data: any;
  loginType: LoginType;
}

export const InquirySideMenuList = ({
  data,
  loginType,
}: InquirySideMenuListProps) => {
  return (
    <S.InquirySideMenuList>
      {data
        .filter((item: any) => {
          return !item.type || item.type === loginType;
        })
        .map((item: any, idx: number) => {
          return <InquirySideMenuItem item={item} key={idx} />;
        })}
    </S.InquirySideMenuList>
  );
};
